import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
// Components
import PurchaseOrderApprovalTable from "./PurchaseOrderApprovalTable"; //reused table component
import PurchaseOrderAllocationTable from "./PurchaseOrderAllocationTable"; //reused table component
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#4f537e",
	},
});

const PurchaseOrderDetailsReference = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in 2nd table
	const [allocation, setAllocation] = useState([]); //data to display in first table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);



	const data = async () => {
		// const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_po_details_reference', {
		 await axios.get(process.env.REACT_APP_API_URL+'get_po_details_reference', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		}).then((res) => {
			console.log(res.data);
			setItems(res.data.data[2].po_details);
			setSupplierInfo(res.data.data[1].supplier_details);
			setShipTotal(res.data.data[1].supplier_details.shipping);
			setPoTotal(res.data.data[1].supplier_details.subtotal);
			// setGrandTotal(res.data.data[1].supplier_details.grand_total);
			setNotes(res.data.data[1].supplier_details.notes);
			setAllocation(res.data.data[0].allocations);
		}).catch((error) => {
			console.log(error);
		});
	};	



	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/purchases/purchases-order-return-transaction-history"}><h4 style={{color:"#339933"}}>Purchase Order Return Transaction History</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Purchase Order Details Reference</h4>
				{/* <h4>supplier id: {supid} - delivery_date: {delivery_date}</h4> test if param values were passed*/}
			</div>
			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Purchase Order Details Reference
								</div>
								<div className={classes.title}>
									Purchase Order Details Reference
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplierInfo.delivery_date || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Delivered To: 
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplierInfo.contactperson || "Delivered To"}
								</Grid>
							</Grid>
							{/* <Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Branch
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplier.branchidno || "Branch"}
								</Grid>
							</Grid> */}
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplierInfo.modeofpayment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Contact #:
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplierInfo.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderAllocationTable items={allocation} type={0} branchidno={branchidno}/>
						<div className={classes.miniTitle}>
									Items
						</div>
						<PurchaseOrderApprovalTable items={items}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Shipping: "+ numeral(shipTotal).format('0,0.00')}							
								</div>
								<div style={{textAlign:"right"}}className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(shipTotal + poTotal).format('0,0.00')}
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
				{/* <div className={classes.buttonContainer}>
					<Button variant="contained">Back</Button> 
					<Button variant="contained" color="primary" onClick={approve_po}>
						Approve
					</Button>
				</div> */}
			</div>
		</div>
	);
};

export default PurchaseOrderDetailsReference;
